import {
  FilterDocument,
  FilterDocumentDateFilterTypes,
  FilterOptionKeys,
} from 'shared/types/filter-document';
import { goalOtherID, lifeAreaOtherID } from 'shared/types/orderable-section';
import { GroupByMode, SortingMode } from 'shared/types/sorting-mode';
import { TaskType } from 'shared/types/task-base';

export const defaultFilterDocument: FilterDocument = {
  sortingMode: SortingMode.Custom,
  groupByMode: GroupByMode.None,
  filters: {
    [FilterOptionKeys.Tag]: null,
    [FilterOptionKeys.Priority]: null,
    [FilterOptionKeys.Duration]: null,
    [FilterOptionKeys.Goal]: {
      include: [goalOtherID],
      noTag: false,
    },
    [FilterOptionKeys.LifeArea]: {
      include: [lifeAreaOtherID],
      noTag: false,
    },
    [FilterOptionKeys.Date]: {
      type: FilterDocumentDateFilterTypes.NoDeadline,
      custom: null,
    },
    [FilterOptionKeys.Deadline]: {
      type: FilterDocumentDateFilterTypes.NoDeadline,
      custom: null,
    },
    [FilterOptionKeys.Type]: {
      include: [TaskType.Task],
      noTag: false,
    },
  },
};
